import _styled from "@emotion/styled-base";
import React from 'react';

// Styled Components via Emotion
var HeroWrapper = _styled("div", {
  target: "e6xdnch0",
  label: "HeroWrapper"
})("color:#ffffff;height:auto;left:0;margin:0 auto;position:absolute;right:0;top:", function (_ref) {
  var top = _ref.top;
  return top || '30%';
}, ";width:90%;", function (_ref2) {
  var align = _ref2.align;
  return align === 'center' ? 'text-align: center;' : '';
}, " ", function (_ref3) {
  var theme = _ref3.theme;
  return theme.MQ.S;
}, "{", function (_ref4) {
  var align = _ref4.align;
  return align === 'center' ? 'text-align: center;' : 'margin: 0; padding-left: 50px; ';
}, "}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.MQ.L;
}, "{", function (_ref6) {
  var align = _ref6.align;
  return align === 'center' ? 'text-align: center;' : 'padding-left: 80px;';
}, "}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9IZXJvL2luZGV4LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLOEIiLCJmaWxlIjoiLi4vLi4vc3JjL0hlcm8vaW5kZXguanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBzdHJpbmcsIG5vZGUgfSBmcm9tICdwcm9wLXR5cGVzJ1xuXG4vLyBTdHlsZWQgQ29tcG9uZW50cyB2aWEgRW1vdGlvblxuY29uc3QgSGVyb1dyYXBwZXIgPSBzdHlsZWQuZGl2YFxuXHRjb2xvcjogI2ZmZmZmZjtcblx0aGVpZ2h0OiBhdXRvO1xuXHRsZWZ0OiAwO1xuXHRtYXJnaW46IDAgYXV0bztcblx0cG9zaXRpb246IGFic29sdXRlO1xuXHRyaWdodDogMDtcblx0dG9wOiAkeyh7IHRvcCB9KSA9PiB0b3AgfHwgJzMwJSd9O1xuXHR3aWR0aDogOTAlO1xuXHQkeyh7IGFsaWduIH0pID0+IChhbGlnbiA9PT0gJ2NlbnRlcicgPyAndGV4dC1hbGlnbjogY2VudGVyOycgOiAnJyl9XG5cblx0JHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5NUS5TfSB7XG5cdFx0JHsoeyBhbGlnbiB9KSA9PiAoYWxpZ24gPT09ICdjZW50ZXInID8gJ3RleHQtYWxpZ246IGNlbnRlcjsnIDogJ21hcmdpbjogMDsgcGFkZGluZy1sZWZ0OiA1MHB4OyAnKX1cblx0fVxuXG5cdCR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuTVEuTH0ge1xuXHRcdCR7KHsgYWxpZ24gfSkgPT4gKGFsaWduID09PSAnY2VudGVyJyA/ICd0ZXh0LWFsaWduOiBjZW50ZXI7JyA6ICdwYWRkaW5nLWxlZnQ6IDgwcHg7Jyl9XG5cdH1cbmBcbkhlcm8ucHJvcFR5cGVzID0ge1xuXHRhbGlnbjogc3RyaW5nLFxuXHRjb250ZW50OiBub2RlLFxuXHR0b3A6IHN0cmluZyxcbn1cblxuLyoqXG4gKiBUaGlzIENvbXBvbmVudCBpcyB0aGUgSGVyb1xuICogVGhpcyB0YWtlcyBjYXJlIG9mIGp1c3QgdGhlIG92ZXJsYXlpbmcgY29udGVudCB3aXRoaW4gdGhlIGhlcm8gYmFubmVyXG4gKiBCYWNrZ3JvdW5kIGltYWdlIGlzIHNldCB3aXRoaW4gSGVyb0Jhbm5lclxuICogKHRoaXMgaXMgYmVjYXVzZSBvZiB0aGUgb3BhY2l0eSBzZXQsIGFuZCBvcmlnaW5hbGx5IHdlIG5lZWRlZCB0byBmbGlwIHRoZSBiYWNrZ3JvdW5kIGltYWdlKVxuICovXG5leHBvcnQgZnVuY3Rpb24gSGVybyh7IGFsaWduLCBjb250ZW50LCB0b3AgfSkge1xuXHRyZXR1cm4gKFxuXHRcdDxIZXJvV3JhcHBlciBhbGlnbj17YWxpZ259IHRvcD17dG9wfT5cblx0XHRcdHtjb250ZW50fVxuXHRcdDwvSGVyb1dyYXBwZXI+XG5cdClcbn1cbiJdfQ== */"));

/**
 * This Component is the Hero
 * This takes care of just the overlaying content within the hero banner
 * Background image is set within HeroBanner
 * (this is because of the opacity set, and originally we needed to flip the background image)
 */
export function Hero(_ref7) {
  var align = _ref7.align,
      content = _ref7.content,
      top = _ref7.top;
  return /*#__PURE__*/React.createElement(HeroWrapper, {
    align: align,
    top: top
  }, content);
}